export const AGENT_PACKAGE_UPGRADE_PATH = "/p/dashboard/management/upgrade";

export function logUpgradeFlowDev(tag, payload = {}) {
  if (import.meta.env.DEV) {
    console.log(tag, payload);
  }
}

/**
 * ניווט אחיד לשדרוג חבילה (סוכן מחובר) — לא לעמוד הרשמה.
 * @param {import('react-router-dom').NavigateFunction} navigate
 * @param {string} [source]
 */
export function navigateAgentPackageUpgrade(navigate, source = "unknown") {
  logUpgradeFlowDev("[UPGRADE_FLOW_CLICK]", { source });
  logUpgradeFlowDev("[UPGRADE_ROUTE_RESOLVE]", { to: AGENT_PACKAGE_UPGRADE_PATH });
  navigate(AGENT_PACKAGE_UPGRADE_PATH);
}
